module.exports = __webpack_public_path__ + "static/media/sucess.3be19d88.mp3";